/**
 * Rounds a given positive floating point number to the nearest number that's an increment of 0.5.
 * For negative numbers it returns 0.
 *
 * E.g.
 * 2.34 => 2.5
 * 2.19 => 2.0
 */
export const roundToNearestHalf = (n: number) => {
  if (n < 0) {
    return 0;
  }

  return Math.round(n * 2) / 2;
};

/**
 * Checks if the supplied value is a valid number.
 * Validity conditions include:
 * - value is not `undefined`
 * - value is not `null`
 * - value is a valid JavaScript `number` type
 * - value is not `NaN`
 * - value is not `-Infinity` or `Infinity`
 */
export const isValidNumber = (n: unknown) => {
  return n !== undefined && n !== null && typeof n === "number" && !Number.isNaN(n) && Number.isFinite(n);
};

/**
 * A utility function that clamps a number to be within a certain range (range includes limit values).
 */
export const DEFAULT_MIN_CLAMP_VALUE = 0;

export const DEFAULT_MAX_CLAMP_VALUE = 100;

export const clampValue = (
  value: number = 0,
  min: number = DEFAULT_MIN_CLAMP_VALUE,
  max: number = DEFAULT_MAX_CLAMP_VALUE
): number => {
  return value < min ? min : value > max ? max : value;
};
